import { alpha, ListItemButton, useTheme } from "@mui/material";
import { useContext } from "react";
import { EntitiyType } from "src/types/apps";

import Context from "../context";
import EntityImage from "./EntityImage";

// ----------------------------------------------------------------------

type Props = {
	item: EntitiyType;
};

const sx = {
	borderRadius: 1,
	p: 4,
	justifyContent: "center",
	cursor: "pointer",
	boxShadow: 2,
	overflow: "hidden"
};

export const EntityItemBtn = ({ item }: Props) => {
	const { entitiesSelected, onSetEntities } = useContext(Context);

	const theme = useTheme();

	const isSelected = entitiesSelected.includes(item.id);

	const onClick = () => {
		if (isSelected) {
			onSetEntities(entitiesSelected.filter((id) => id !== item.id));
		} else {
			onSetEntities([...entitiesSelected, item.id]);
		}
	};

	return (
		<ListItemButton
			key={item.id}
			onClick={onClick}
			sx={{
				...sx,
				backgroundColor: isSelected ? alpha(theme.palette.primary.main, 0.15) : "none",
				"&:hover ": {
					backgroundColor: isSelected
						? alpha(theme.palette.primary.main, 0.25)
						: theme.palette.action.hover
				}
			}}
		>
			<EntityImage name={item.name} id={item.id} />
			{/* <FotterMark color='primary' /> */}
		</ListItemButton>
	);
};

export default EntityItemBtn;
